var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "single_slider  wow fadeInDown",
      attrs: { "data-wow-delay": "0.7s" },
    },
    [
      _c(
        "agile",
        { attrs: { "initial-slide": 0, options: _vm.options_main_slider } },
        [
          _vm._l(_vm.items, function (item, i) {
            return _c(
              "div",
              { key: i, staticClass: "slide", attrs: { src: item.src } },
              [
                _c("img", {
                  staticClass: "slide wow fadeInRight",
                  attrs: { src: item.src, "data-wow-delay": "0.9s" },
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "single_slider__descr wow fadeInDown",
                    attrs: { "data-wow-delay": "0.9s" },
                  },
                  [
                    _c("div", { staticClass: "single_slider__title" }, [
                      _vm._v(_vm._s(item.title)),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "single_slider__sm_title" }, [
                      _vm._v(_vm._s(item.sm_title)),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "single_slider__sm_descr",
                        domProps: { innerHTML: _vm._s(item.descr) },
                      },
                      [_vm._v(_vm._s(item.descr))]
                    ),
                  ]
                ),
              ]
            )
          }),
          _vm._v(" "),
          _c("template", { slot: "prevButton" }, [
            _c(
              "svg",
              {
                attrs: {
                  width: "19",
                  height: "18",
                  viewBox: "0 0 19 18",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg",
                },
              },
              [
                _c("path", {
                  attrs: {
                    d: "M11.5 4.5L7 9L11.5 13.5",
                    stroke: "white",
                    "stroke-width": "2.4",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                  },
                }),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("template", { slot: "nextButton" }, [
            _c(
              "svg",
              {
                attrs: {
                  width: "19",
                  height: "18",
                  viewBox: "0 0 19 18",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg",
                },
              },
              [
                _c("path", {
                  attrs: {
                    d: "M7.5 13.5L12 9L7.5 4.5",
                    stroke: "white",
                    "stroke-width": "2.4",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                  },
                }),
              ]
            ),
          ]),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }